import pino from 'pino'
import * as Sentry from '@sentry/nextjs'

export const logger = pino({
  level: process.env.NODE_ENV !== 'production' ? 'debug' : 'warn',
  // level: 'debug',
  transport:
    typeof window === 'undefined'
      ? {
          target: 'pino-pretty',
          options: {
            colorize: true,
          },
        }
      : undefined,
  timestamp: pino.stdTimeFunctions.isoTime,
  formatters: {
    level: label => ({level: label}),
  },
  mixin() {
    const span = Sentry.getActiveSpan()

    if (!span) {
      return {}
    }

    const ctx = span.spanContext()

    return {
      trace_id: ctx.traceId,
      span_id: ctx.spanId,
    }
  },
})
